// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banner":"offline-banner__banner--2owL6","fadeIn":"offline-banner__fadeIn--3ed_M"};